import React, { useEffect, useState } from 'react';
import {
  Breadcrumb,
  Button,
  ConfigProvider,
  DatePicker,
  Form,
  Input,
  Select,
  Space,
  Switch,
  Collapse,
} from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import plPL from 'antd/lib/locale/pl_PL';
import 'moment/locale/pl';
import 'moment-timezone';
import FormCoverUpload from 'modules/galleryModules/components/FormCoverUpload';
import TextEditor from 'modules/layoutModule/components/TextEditor/TextEditor';
import { FieldData } from 'rc-field-form/lib/interface';
import copyToClipboard from 'helpers/copyToClipboard';
import { createGtwArticle, getGtwCategories } from '../requests/gtwRequests';

const { TextArea } = Input;
const { Panel } = Collapse;

const GtwArticlesAdd = (): JSX.Element => {
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [form] = Form.useForm();
  const [categories, setCategories] = useState([]);
  const [fileImage1, setFileImage1] = useState<string | null>(null);
  const [fileImage2, setFileImage2] = useState<string | null>(null);
  const [fileImage3, setFileImage3] = useState<string | null>(null);
  const [fileImage4, setFileImage4] = useState<string | null>(null);
  const [fileImage5, setFileImage5] = useState<string | null>(null);
  const [fileImage6, setFileImage6] = useState<string | null>(null);
  const [fileImage7, setFileImage7] = useState<string | null>(null);
  const [fileImage8, setFileImage8] = useState<string | null>(null);
  const [fileImage9, setFileImage9] = useState<string | null>(null);
  const [fileImage10, setFileImage10] = useState<string | null>(null);
  const [fields, setFields] = useState<FieldData[]>([]);

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  useEffect(() => {
    getGtwCategories().then((response) => {
      if (response) {
        const onlyActiveCategories = response.filter(
          (category: { isActive: any }) => category.isActive
        );

        const categories = onlyActiveCategories.map(
          (category: { name: string; id: number }) => ({
            label: category.name,
            value: category.id,
          })
        );

        setCategories(categories);
      }
    });
  }, []);

  const onSubmitForm = (values: any) => {
    toggleButtonLoading(true);
    createGtwArticle(values).then(() => toggleButtonLoading(false));
  };

  const onContentEdit = (e: any) => {
    setFields([
      {
        name: ['content'],
        value: e,
      },
    ]);
  };

  const updateCover = (
    e: string,
    field: string,
    coverMethod: (value: string) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
  };

  const updateFile = (
    e: string,
    field: string,
    coverMethod: (value: string) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Grunt to Wiedza</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/gtw-art">Baza wiedzy</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/gtw-art/add">+</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <div className="site-layout-background">
        <ConfigProvider locale={plPL}>
          <Form
            layout="vertical"
            validateMessages={validateMessages}
            onFinish={onSubmitForm}
            form={form}
            fields={fields}
          >
            <Form.Item
              name="fileImage1"
              label="Okładka"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <FormCoverUpload
                cover={fileImage1}
                setCover={(e) => updateCover(e, 'fileImage1', setFileImage1)}
                isNew
                field="fileImage1"
                number={1}
              />
            </Form.Item>
            <Form.Item
              name="alt1"
              label="Opis zdjęcia okładki (widoczne po dodaniu w treści wybranego kodu)"
            >
              <Input />
            </Form.Item>
            <Form.Item name="fileImage2" label="Obrazek 2">
              <FormCoverUpload
                cover={fileImage2}
                setCover={(e) => updateCover(e, 'fileImage2', setFileImage2)}
                isNew
                field="fileImage2"
                number={2}
              />
            </Form.Item>
            <Form.Item name="alt2" label="Opis zdjęcia 2">
              <Input />
            </Form.Item>
            <Form.Item name="fileImage3" label="Obrazek 3">
              <FormCoverUpload
                cover={fileImage3}
                setCover={(e) => updateCover(e, 'fileImage3', setFileImage3)}
                isNew
                field="fileImage3"
                number={3}
              />
            </Form.Item>
            <Form.Item name="alt3" label="Opis zdjęcia 3">
              <Input />
            </Form.Item>
            <Form.Item name="fileImage4" label="Obrazek 4">
              <FormCoverUpload
                cover={fileImage4}
                setCover={(e) => updateCover(e, 'fileImage4', setFileImage4)}
                isNew
                field="fileImage4"
                number={4}
              />
            </Form.Item>
            <Form.Item name="alt4" label="Opis zdjęcia 4">
              <Input />
            </Form.Item>
            <Form.Item name="fileImage5" label="Obrazek 5">
              <FormCoverUpload
                cover={fileImage5}
                setCover={(e) => updateCover(e, 'fileImage5', setFileImage5)}
                isNew
                field="fileImage5"
                number={5}
              />
            </Form.Item>
            <Form.Item name="alt5" label="Opis zdjęcia 5">
              <Input />
            </Form.Item>
            <Form.Item name="fileImage6" label="Obrazek 6">
              <FormCoverUpload
                cover={fileImage6}
                setCover={(e) => updateCover(e, 'fileImage6', setFileImage6)}
                isNew
                field="fileImage6"
                number={6}
              />
            </Form.Item>
            <Form.Item name="alt6" label="Opis zdjęcia 6">
              <Input />
            </Form.Item>
            <Form.Item name="fileImage7" label="Obrazek 7">
              <FormCoverUpload
                cover={fileImage7}
                setCover={(e) => updateCover(e, 'fileImage7', setFileImage7)}
                isNew
                field="fileImage7"
                number={7}
              />
            </Form.Item>
            <Form.Item name="alt7" label="Opis zdjęcia 7">
              <Input />
            </Form.Item>
            <Form.Item name="fileImage8" label="Obrazek 8">
              <FormCoverUpload
                cover={fileImage8}
                setCover={(e) => updateCover(e, 'fileImage8', setFileImage8)}
                isNew
                field="fileImage8"
                number={8}
              />
            </Form.Item>
            <Form.Item name="alt8" label="Opis zdjęcia 8">
              <Input />
            </Form.Item>
            <Form.Item name="fileImage9" label="Obrazek 9">
              <FormCoverUpload
                cover={fileImage9}
                setCover={(e) => updateCover(e, 'fileImage9', setFileImage9)}
                isNew
                field="fileImage9"
                number={9}
              />
            </Form.Item>
            <Form.Item name="alt9" label="Opis zdjęcia 9">
              <Input />
            </Form.Item>
            <Form.Item name="fileImage10" label="Obrazek 10">
              <FormCoverUpload
                cover={fileImage10}
                setCover={(e) => updateCover(e, 'fileImage10', setFileImage10)}
                isNew
                field="fileImage10"
                number={10}
              />
            </Form.Item>
            <Form.Item name="alt10" label="Opis zdjęcia 10">
              <Input />
            </Form.Item>

            <Form.Item
              name="dateAdd"
              label="Data dodania"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              {/*// @ts-ignore*/}
              <DatePicker showTime />
            </Form.Item>
            <Form.Item
              name="idCategory"
              label="Kategoria"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Wybierz kategorię"
                optionFilterProp="children"
                options={categories}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item
              name="name"
              label="Tytuł"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="content"
              label="Treść"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              {/* @ts-ignore */}
              <TextEditor onChange={onContentEdit} disableGallery />
            </Form.Item>
            <Form.Item name="youtubeURL1" label="Link do youtube nr. 1">
              <Input />
            </Form.Item>

            <Form.Item name="youtubeURL2" label="Link do youtube nr. 2">
              <Input />
            </Form.Item>
            <Form.Item name="youtubeURL3" label="Link do youtube nr. 3">
              <Input />
            </Form.Item>
            <div className="tables-collapse">
              <Collapse defaultActiveKey={[]}>
                <Panel header="Tabelka 1" key="1" forceRender>
                  <Form.Item name="table1" label="Tabelka 1">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#1')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#1
                  </Button>
                </Panel>
                <Panel header="Tabelka 2" key="2" forceRender>
                  <Form.Item name="table2" label="Tabelka 2">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#2')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#2
                  </Button>
                </Panel>
                <Panel header="Tabelka 3" key="3" forceRender>
                  <Form.Item name="table3" label="Tabelka 3">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#3')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#3
                  </Button>
                </Panel>
                <Panel header="Tabelka 4" key="4" forceRender>
                  <Form.Item name="table4" label="Tabelka 4">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#4')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#4
                  </Button>
                </Panel>
                <Panel header="Tabelka 5" key="5" forceRender>
                  <Form.Item name="table5" label="Tabelka 5">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#5')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#5
                  </Button>
                </Panel>
              </Collapse>
            </div>
            <Form.Item
              name="isActive"
              label="Aktywność"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
            <Form.Item>
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                  loading={isSaveButtonLoading}
                >
                  Zapisz
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </ConfigProvider>
      </div>
    </>
  );
};

export default GtwArticlesAdd;
